import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CurrencyFormat from "react-currency-format";
import TextField from "@mui/material/TextField";
import { NumericFormat } from "react-number-format";
import { GetPriceDataStore } from "../../store/priceListAtom";
import Select from "react-select";
import PriceUploadModal from "./PriceUploadModal";
import * as XLSX from "xlsx";
import LogicContext from "../../Context/LogicContext";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import * as _ from "underscore";
import Tooltip from "@mui/material/Tooltip";
import CopyPriceModal from "./CopyPriceModal";
import { Switch } from "antd";



export default function PriceDetailsTable(props) {
  const [tableDataList, setTableDataList] = React.useState([]);
  const [defOption, setDefOption] = React.useState(null);
  const [optionList, setOptionList] = React.useState([]);
  const priceData = GetPriceDataStore();
  const logicContext = React.useContext(LogicContext);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#f9fafb",
      borderColor: state.isFocused ? "#0000FF" : "#d1d5db",
      boxShadow: state.isFocused ? "0 0 0 1px #9ca3af" : "none",
      height: 42,
      borderRadius: 6,
      paddingLeft: 4,
      paddingRight: 4,
      fontSize: 14,
      width: "100%",
      transition: "all 0.2s ease-in-out",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0 8px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9ca3af",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#111827",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? "#6b7280" : "#9ca3af",
      "&:hover": {
        color: "#6b7280",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#ffffff",
      borderRadius: 6,
      boxShadow: "0 4px 14px rgba(0, 0, 0, 0.05)",
      marginTop: 4,
      fontSize: 14,
      boxShadow: "0 0 0 1px #d1d5db",
      zIndex: 9999, // 👈 high z-index here
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#FFFFFF"
        : state.isFocused
        ? "#f3f4f6"
        : "#ffffff",
      color: "#111827",
      padding: "8px 12px",
      cursor: "pointer",
      borderColor: state.isFocused ? "#9ca3af" : "#d1d5db",
      "&:hover": {
        backgroundColor: "#f3f4f6",
      },
      border: "2px",
      transition: "background-color 0.2s ease",
    }),
    // Optional, if you’re using menuPortalTarget:
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  
  React.useEffect(() => {
    let newList = priceData.item_group.map((item) => {
      return { ...item, label: item?.Product_Name };
    });
    setOptionList(newList);
    if (newList?.length) {
      setDefOption(newList[0]);
      props?.onProductSelect(newList[0]);
    }
  }, [priceData.item_group, props?.cor_id]);

  React.useEffect(() => {
    setTableDataList(props?.data);

    return () => {};
  }, [props?.data]);

  const itemSearchChange = (ev) => {
    const search = ev?.target.value;
    if (search < 1) {
      setTableDataList(props?.data);
    } else {
      var tempResult = props?.data?.filter((product) => {
        return (
          product?.Item_Type_Name?.toLowerCase().indexOf(
            search.toLowerCase()
          ) >= 0 ||
          product?.Item_SKU?.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
          product?.Item_Id?.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
          product?.Item_Name?.toLowerCase().indexOf(search.toLowerCase()) >= 0
        );
      });

      setTableDataList(tempResult);
    }
  };

  const onFileUpload = (file) => {
    let uploadedFile = file.target.files[0];
    const fileType = file.target.files[0]?.name.split(".")[1];
    let tempUpload = [];
    if (fileType === "csv") {
      var reader = new FileReader();
      reader.onload = function (e) {
        const csvFile = e.target.result;
        let lines = csvFile.split("\n");

        let newList = [...tableDataList];

        let tempObj = {
          Item_Name: "",
          Item_Rate_Market: 0,
          Item_Rate_Zoho: 0,
          status: "",
        };
        let counter = 0;
        for (let i = 0; i < lines.length; i++) {
          const element = lines[i];
          if (i !== 0 && counter < newList.length) {
            tempUpload.push(counter);
            if (element) {
              tempObj.Item_Name = element.split(",")[0]
                ? element.split(",")[0]
                : 0;
              tempObj.Item_Rate_Market = element.split(",")[1]
                ? Number(element.split(",")[1])
                : 0;
              tempObj.Item_Rate_Zoho = element.split(",")[2]
                ? Number(element.split(",")[2])
                : 0;
              tempObj.status = "";
            }

            if (tempObj.Item_Name?.length < 2) {
              tempObj.status = "Not valid";
            }
            let storedData = newList[counter];
            newList[counter] = { ...storedData, ...tempObj };
            counter += 1;
          }
        }
        // setRowSelectionModel(tempUpload);
        let temp = [];
        for (let i = 1; i < tempUpload.length; i++) {
          let element = tableDataList[i];
          temp.push(element?.Ref_No);
        }

        setTableDataList(newList);
      };
      reader.readAsText(uploadedFile);
      // end csv
    } else if (fileType === "xlsx") {
      // For Excel file
      var reader = new FileReader();
      reader.readAsArrayBuffer(file.target.files[0]);
      reader.onload = function (e) {
        var data = new Uint8Array(reader.result);
        var workbook = XLSX.read(data, { type: "array" });
        var sheet = workbook.Sheets[workbook.SheetNames[0]];
        let jsonList = XLSX.utils.sheet_to_json(sheet);

        let newList = [...tableDataList];

        let tempObj = {
          Item_Name: "",
          Item_Rate_Market: 0,
          Item_Rate_Zoho: 0,
          status: "",
        };

        let counter = 0;
        for (let i = 0; i < jsonList.length; i++) {
          const element = jsonList[i];

          if (element?.Item_Name) {
            tempUpload.push(counter);
            tempObj.status = "";
            tempObj.Item_Name = element?.Item_Name ? element?.Item_Name : "";
            tempObj.Item_Rate_Market = element?.Item_Rate_Market
              ? Number(element?.Item_Rate_Market)
              : 0;
            tempObj.Item_Rate_Zoho = element?.Item_Rate_Zoho
              ? Number(element?.Item_Rate_Zoho)
              : "";

            let storedData = newList[counter];
            newList[counter] = { ...storedData, ...tempObj };
            counter += 1;
          }
        }

        let temp = [];
        for (let i = 0; i < tempUpload.length; i++) {
          let element = tableDataList[i];
          temp.push(element?.Ref_No);
        }

        setTableDataList(newList);
      };
    }
  };

  const onMarketValueChange = (value, product, i) => {
    if (Number(value) < 0) {
      return logicContext.showToast("Negative value is accepted.", "error");
    }
    if (tableDataList.length < props.data.length) {
      let productData = {
        ...product,
        Item_Rate_Market: Number(value ? value : 0),
      };
      setTableDataList((prevList) => {
        let newList = prevList?.map((tempProd) => {
          if (tempProd.Item_Id === productData.Item_Id) {
            return productData;
          } else {
            return tempProd;
          }
        });
        setTableDataList(newList);
      });
    } else {
      props?.onMarketValueChange(value, product, i);
    }
  };

  const onGrocedyValueChange = (value, product, i) => {
    if (Number(value) < 0) {
      return logicContext.showToast("Negative value is accepted.", "error");
    }
    if (tableDataList.length < props.data.length) {
      let productData = {
        ...product,
        Item_Rate_Zoho: Number(value ? value : 0),
      };
      setTableDataList((prevList) => {
        let newList = prevList?.map((tempProd) => {
          if (tempProd.Item_Id === productData.Item_Id) {
            return productData;
          } else {
            return tempProd;
          }
        });
        setTableDataList(newList);
      });
    } else {
      props?.onGrocedyValueChange(value, product, i);
    }
  };

  const pricePercentChange = _.debounce((value) => {
    props.onGrocedyPercentChange(value);
  }, 1600);

  const handleToggleChange = (checked, product, i) => {
    let newTempList = [...tableDataList];
    let item = newTempList[i];
    let newStatus = checked === true ? "Active" : "Inactive";
    item.status = newStatus;
    newTempList[i] = item;
    setTableDataList(newTempList);

    let newData = { sku: item?.Item_SKU, status: newStatus };
    props.updateStatus(newData);
  };

  return (
    <>
      <TableContainer component={Paper} className="overflow-hidden">
        <div className="mt-4 mb-4 px-2">
          <div className="grid grid-auto-fit-xs gap-4">
            <div className="">
              <Select
                key={defOption}
                defaultValue={defOption}
                onChange={(e) => props?.onProductSelect(e)}
                options={optionList}
                styles={customStyles}
              />
            </div>
            <div className="relative">
              <Tooltip
                title="Set discount for Grocedy Price."
                className="show-cursor"
              >
                <NumericFormat
                  className="h-[42px] w-full border border-gray-200 rounded"
                  value={0}
                  de
                  onValueChange={(values, sourceInfo) => {
                    pricePercentChange(values.value);
                  }}
                />
                <small className="absolute top-2 right-2 text-base text-primary">
                  %
                </small>
              </Tooltip>
            </div>
          </div>{" "}
          <div className="mt-4 sm:flex sm:flex-row sm:items-center sm:space-x-4">
            <div className="w-full max-w-sm">
              <TextField
                variant="outlined"
                label="Search..."
                size="small"
                fullWidth
                onChange={itemSearchChange}
                className="bg-white shadow-sm rounded-md"
                InputProps={{
                  sx: {
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // 🔥 removes the inner border (outline)
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    backgroundColor: "white",
                    borderRadius: "0.5rem", // rounded-md
                    boxShadow: "inset 0 0 0 1px #e5e7eb", // subtle Tailwind-style border
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: "0.9rem",
                  },
                }}
              />
            </div>

            {/* % end */}
            <div className="flex flex-row items-center space-x-4">
              <div>
                <PriceUploadModal
                  onFileUpload={onFileUpload}
                  tableDataList={tableDataList}
                />
              </div>
              <div>
                <CopyPriceModal
                  productCatId={props.productCatId}
                  tableDataList={tableDataList}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
    <Table
      aria-label="customized table"
      className="min-w-[800px] sm:min-w-full" // set min width so it scrolls on xs
    >
      <TableHead>
        <TableRow className="bg-gray-200">
          <TableCell className="text-sm font-semibold text-gray-700 px-6 py-3 border-b border-gray-200">
            Name
          </TableCell>
          <TableCell className="text-sm font-semibold text-gray-700 px-6 py-3 border-b border-gray-200">
            SKU
          </TableCell>
          <TableCell className="text-sm font-semibold text-gray-700 px-6 py-3 border-b border-gray-200">
            Market Price(₦)
          </TableCell>
          <TableCell className="text-sm font-semibold text-gray-700 px-6 py-3 border-b border-gray-200">
            Grocedy Price(₦)
          </TableCell>
          <TableCell className="text-sm font-semibold text-gray-700 px-6 py-3 border-b border-gray-200">
            Status
          </TableCell>
          <TableCell className="text-sm font-semibold text-gray-700 px-6 py-3 border-b border-gray-200">
            Action
          </TableCell>
          <TableCell className="text-sm font-semibold text-gray-700 px-6 py-3 border-b border-gray-200">
            History
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {tableDataList?.length > 0 &&
          tableDataList.map((product, i) => (
            <TableRow
              key={i}
              className="hover:bg-gray-50 transition"
            >
              <TableCell className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200">
                <span
                  title={product.Item_Name}
                  className="max-w-[100px] truncate  cursor-default"
                >
                  {product.Item_Name}
                </span>
              </TableCell>
              <TableCell
                align="right"
                className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200"
              >
                <div
                  title={product?.Item_SKU}
                  className="max-w-[100px] truncate  cursor-default"
                >
                  {product?.Item_SKU}
                </div>
              </TableCell>

              {/* Market price */}
              <TableCell
                align="right"
                className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200"
              >
                <NumericFormat
                  value={product?.Item_Rate_Market}
                  className="h-8 w-[100px] border border-gray-200 rounded"
                  thousandSeparator=","
                  decimalSeparator="."
                  onValueChange={(values) =>
                    onMarketValueChange(values.value, product, i)
                  }
                />
              </TableCell>

              {/* Grocedy price */}
              <TableCell
                align="right"
                className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200"
              >
                <NumericFormat
                  value={product?.Item_Rate_Zoho}
                  className="h-8 w-[100px] border border-gray-200 rounded"
                  thousandSeparator=","
                  decimalSeparator="."
                  onValueChange={(values) =>
                    onGrocedyValueChange(values.value, product, i)
                  }
                />
              </TableCell>

              {/* Status */}
              <TableCell
                align="right"
                className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200"
              >
                <Switch
                  checked={product.status === "Active"}
                  onChange={(checked) =>
                    handleToggleChange(checked, product, i)
                  }
                />
              </TableCell>

              {/* Action */}
              <TableCell
                onClick={() => props.sendSingleItem(i, product)}
                align="right"
                className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200"
              >
                <button className="px-3 text-xs py-1.5 bg-blue-500 hover:bg-blue-600 text-white rounded">
                  SEND
                </button>
              </TableCell>

              <TableCell
                align="right"
                className="text-xs text-gray-800 px-6 py-3 border-b border-gray-200"
              >
                <button className="px-2 text-xs py-1.5 bg-gray-100 hover:bg-gray-200 rounded-sm">
                  HISTORY
                </button>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  </div>
        {/* Table End */}

       
        <div class="d-flex align-items-end flex-column mt-3 mb-3 ">
          <button
            onClick={() => props.sendAllProductItems(tableDataList)}
            className="bg-blue-600 text-white hover:bg-blue-700 flex flex-row items-center text-sm font-medium px-3 py-2 rounded-md transition-colors mr-3"
          >
            SAVE ALL
          </button>
        </div>
      </TableContainer>

      <br />
      <br />
    </>
  );
}
